export default "__VITE_PUBLIC_ASSET__2b0488e4__"